import React from 'react';
import { Field } from '../../ui/Field';
import { TextInput } from '../../ui/TextControl';
import { asDraft } from '../../../types/registration';
import type { QuestionProps } from './types';
export function NameQuestion({
  data,
  update
}: QuestionProps) {
  const draft = asDraft(data);
  const preview = `${draft.firstName.trim() || 'First name'} ${draft.lastName.trim().charAt(0) || ''}${draft.lastName.trim() ? '.' : ''}`.trim();
  return <div className="flex flex-col gap-5" data-id="element-454" data-mp="2qfrbttm378ms">
      <div className="grid gap-4 sm:grid-cols-2" data-id="element-455" data-mp="2v8ao8n91fxq0">
        <Field name="firstName" label="First name" data-id="element-456" data-mp="2v928j1x6q90z">
          <TextInput id="firstName" name="firstName" autoComplete="given-name" value={draft.firstName} onChange={event => update({
          firstName: event.target.value
        })} data-id="element-457" data-mp="2hgw3aavklmgb" />
        </Field>

        <Field name="lastName" label="Last name" data-id="element-458" data-mp="27k9l5tump9hz">
          <TextInput id="lastName" name="lastName" autoComplete="family-name" value={draft.lastName} onChange={event => update({
          lastName: event.target.value
        })} data-id="element-459" data-mp="2chj9152ddd3p" />
        </Field>
      </div>

      <p className="text-small text-ink-muted" data-id="element-460" data-mp="ysm4d6aa82l6">
        Other members would see{' '}
        <span className="font-medium text-ink" data-id="element-461" data-mp="1cnwrfxiabjez">{preview}</span>, never your full surname.
      </p>
    </div>;
}